(function () {
  'use strict';

  const PROXY_URL ='https://lumiyre-silver-server-production-3eb5.up.railway.app/apps/lumiyre-silver/price';
  const REFRESH_MS = 60000;
  const SESSION_KEY = 'lumiyre_silver_dismissed';

  var lastPrice = null;

  function fmt(v) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: 4, maximumFractionDigits: 4,
    }).format(v);
  }

  async function fetchPrice() {
    var isDevOrEditor = (window.Shopify && window.Shopify.designMode) ||
      location.hostname === 'localhost';
    if (isDevOrEditor) {
      await new Promise(function (r) { setTimeout(r, 700); });
      var dir = Math.random() > 0.5 ? 1 : -1;
      return (lastPrice || 1.0312) + dir * (Math.random() * 0.006);
    }
    var res = await fetch(PROXY_URL, {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      signal: AbortSignal.timeout(8000),
    });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    var data = await res.json();
    if (typeof data.pricePerGram !== 'number') throw new Error('Bad payload');
    return data.pricePerGram;
  }

  function applyDirection(priceEl, arrowEl, newPrice) {
    ['up', 'down', 'flat'].forEach(function (d) {
      priceEl.classList.remove('lumiyre-silver-bar__price--' + d);
      arrowEl.classList.remove('lumiyre-silver-bar__arrow--' + d);
    });
    var dir = 'flat';
    var symbol = '—';
    if (lastPrice !== null) {
      if (newPrice > lastPrice) { dir = 'up'; symbol = '↑'; }
      else if (newPrice < lastPrice) { dir = 'down'; symbol = '↓'; }
    }
    priceEl.classList.add('lumiyre-silver-bar__price--' + dir);
    arrowEl.classList.add('lumiyre-silver-bar__arrow--' + dir);
    arrowEl.textContent = symbol;
    lastPrice = newPrice;
  }

  function setLoading(priceEl, arrowEl) {
    priceEl.innerHTML = '<span class="lumiyre-silver-bar__dots"><span></span><span></span><span></span></span>';
    arrowEl.textContent = '';
  }

  function setError(priceEl, arrowEl) {
    priceEl.removeAttribute('data-updating');
    priceEl.innerHTML = '<span style="opacity:0.35;font-size:9px;letter-spacing:0.1em">—</span>';
    arrowEl.textContent = '';
  }

  async function refresh(priceEl, arrowEl) {
    priceEl.setAttribute('data-updating', '');
    try {
      var price = await fetchPrice();
      priceEl.removeAttribute('data-updating');
      priceEl.innerHTML = '<span>' + fmt(price) + '</span>';
      applyDirection(priceEl, arrowEl, price);
    } catch (e) {
      console.warn('[Lumiyre Silver]', e.message);
      setError(priceEl, arrowEl);
    }
  }

  function init() {
    var bar = document.getElementById('lumiyre-silver-bar');
    if (!bar) return;
    if (sessionStorage.getItem(SESSION_KEY) === '1') {
      bar.setAttribute('hidden', '');
      return;
    }
    var priceEl = bar.querySelector('[data-lumiyre-price]');
    var arrowEl = bar.querySelector('[data-lumiyre-arrow]');
    var closeBtn = bar.querySelector('[data-lumiyre-close]');
    if (!priceEl || !arrowEl || !closeBtn) return;

    closeBtn.addEventListener('click', function () {
      bar.setAttribute('hidden', '');
      sessionStorage.setItem(SESSION_KEY, '1');
    });

    setLoading(priceEl, arrowEl);
    refresh(priceEl, arrowEl);
    setInterval(function () {
      refresh(priceEl, arrowEl);
    }, REFRESH_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();